import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

import Button from '@mui/material/Button';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import CssBaseline from '@mui/material/CssBaseline';

export const LandingHeader = () => {
  return (
    <header
      style={{
        display: 'flex',
        position: 'fixed',
        zIndex: 999,
        backdropFilter: 'blur(5px)',
        width: '100%',
        padding: '0.7em 4em',
      }}
    >
      <CssBaseline />
      <Typography color="white" variant="h3" component="h3">
        RezyList
      </Typography>
      <nav
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          flexDirection: 'row',
          width: 'auto',
        }}
      >
        <Link href="#home" underline="none" color="white" margin="0 15px">
          Home
        </Link>
        <Link href="#features" underline="none" color="white" margin="0 15px">
          What we do
        </Link>
        <Link href="#about" underline="none" color="white" margin="0 15px">
          Our service
        </Link>
        <Link href="#contact" underline="none" color="white" margin="0 15px">
          Contact
        </Link>
      </nav>
      <div>
        <RouterLink to="/sign-up">
          <Button style={{ color: 'white' }}>Sign up</Button>
        </RouterLink>
        <RouterLink to="/sign-in">
          <Button variant="contained">Sign In</Button>
        </RouterLink>
      </div>
    </header>
  );
};
